// UserProvider.js
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import UserContext from "./UserContext";
import * as apicall from "../Apicall";

const UserProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const vendorCache = useRef({}); // Using ref instead of state for cache

  const fetchVendorData = useCallback(async (vendorId) => {
    if (!vendorId) {
      setVendor(null);
      setLoading(false);
      return;
    }

    // Check cache first
    if (vendorCache.current[vendorId]) {
      setVendor(vendorCache.current[vendorId]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("vendorId------", vendorId);
      const response = await apicall.get(`get_vendor_details?id=${vendorId}`);
      if (
        response.success &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        const vendorData = response.data[0];
        let services = response.data?.map((ele) => {
          return {
            service_icon: ele?.service_icon,
            service_id: ele?.service_id,
            service_name: ele?.service_name,
          };
        });
        console.log("services---", services);
        localStorage.setItem("services", JSON.stringify(services));

        // Update cache
        vendorCache.current = {
          ...vendorCache.current,
          [vendorId]: vendorData,
        };
        setVendor(vendorData);
      } else {
        setVendor(null);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setVendor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // const vendorId = localStorage.getItem('vendorId');
    const userId = localStorage.getItem("userId");
    fetchVendorData(userId);

    const handleStorageChange = (e) => {
      if (e.key === "userId") {
        fetchVendorData(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [fetchVendorData]);

  const refreshVendorData = useCallback(() => {
    // const vendorId = localStorage.getItem("vendorId");
    const userId = localStorage.getItem("userId");
    fetchVendorData(userId);
  }, [fetchVendorData]);

  const contextValue = useMemo(
    () => ({
      vendor,
      loading,
      refreshVendorData,
    }),
    [vendor, loading, refreshVendorData]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
